import React, {useEffect, useRef, useState} from "react";
import RatingSliderBox from "./RatingSliderBox";
import ArrowButtonsRatingSlider from "./ArrowButtonsRatingSlider";
import apiService from "../../../services/apiService";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const RatingSlider = () => {
	const [data, setData] = useState([]);


	useEffect(() => {
		apiService
			.getCustomerOpinions()
			.then((response) => {
				setData(response.data);
			})
			.catch((err) => {

			});
	}, []);
	const swiperRef = useRef(null);
	const [isEnd, setIsEnd] = useState(false);
	const [isBeginning, setIsBeginning] = useState(true);

	return (
		<section className=' h-[380px] relative'>
			<RatingSliderBox
				sliders={data}
				swiperRef={swiperRef}
				setIsBeginning={setIsBeginning}
				setIsEnd={setIsEnd}
			/>
			{ data.length > 1 && 	<ArrowButtonsRatingSlider
				isEnd={isEnd}
				swiperRef={swiperRef}
				addLineBetweenArrows={false}
				isBeginning={isBeginning}
			/> }

		</section>
	);
};

export default RatingSlider;
